import React from 'react'

import classes from './ProgressIndicator.module.scss'

function ProgressIndicator({currentIndex, itemcount, onPress}){

    let items = []

    for (let index = 0; index < itemcount; index++) {
        items.push(
            <span 
                key={index}
                className={`${classes.ProgressIndicator__item} ${(currentIndex === index ? classes['ProgressIndicator__item--active'] : "")}`}
                onClick={() => {onPress(index)}}
                />
        );
    }

	return (
		<section className={`${classes.ProgressIndicator}`}>
            {items}
        </section>
	)
}

export default ProgressIndicator